import { cva } from 'class-variance-authority';

export const filterListVariants = cva(
  'grid grid-cols-3 gap-2 divide-x [&>div]:pl-[8px]',
  {
    variants: {
      cols: {
        1: 'grid-cols-1 [&>div:nth-child(n)]:!border-l-0',
        2: 'grid-cols-2 [&>div:nth-child(2n+1)]:!border-l-0',
        3: 'grid-cols-3 [&>div:nth-child(3n+1)]:!border-l-0',
        4: 'grid-cols-4 [&>div:nth-child(4n+1)]:!border-l-0',
      },
    },
    defaultVariants: {
      cols: 3,
    },
  },
);
